import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-themeblock',
  templateUrl: './themeblock.component.html',
  styleUrls: ['./themeblock.component.css']
})
export class ThemeblockComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
